module.exports = __webpack_public_path__ + "img/logo.af2680da.png";